export const NAME = "validationReportsPage" as const;
